import gql from 'graphql-tag';
import { fileQueryFields, stateQueryFields, municipalityQueryFields, userQueryFields } from './common.queries';

const serasaApiData = `
  reports {
    taxIdentifier
    dateReport
    status
    occurrences {
      name
      balance
      count
      firstOccurrence
      lastOccurrence
    }
  }
`;

const phase1Info = `
  status
  createdAt
  decisionBy
  decisionAt
  notes
  ibamaNotes
  ibamaEvaluation
  serasaEvaluation
  serasa {
    type
    name
    amount
  }
  serasaNotes
  laborEvaluation
  stateJudicialCheckEvaluation
  stateJudicialCheck {
    type
    name
    amount
  }
  stateJudicialCheckNotes
  files {
    ${fileQueryFields}
  }
  serasaApiData {
    ${serasaApiData}
  }
`;

const creditInfo = `
  id
  status
  decisionNotes
  decisionChangedAt
  decisionChangedBy {
    ${userQueryFields}
  }
  isDone
  pendencies
  startedAt
  startedBy
  markAsCompleteBy
  markAsCompleteAt
  notes
  shareholderPartner {
    fullName
    CNPJ
    position
    participation
  }
  shareholderCompany {
    name
    CNPJ
    participation
  }
  customerActivityType
  customerProducts
  customerDescription
  serasaConsultationDate
  serasaDebts {
    type
    name
    amount
  }
  serasaObservation
  returnOfIncomeCosting
  returnOfIncomeDebts
  returnOfIncomeGrossRevenue
  returnOfIncomeInvestment
  returnOfIncomePatrimony
  returnOfIncomeResult
  returnOfIncomeRural
  returnOfIncomeTaxableIncome
  returnOfIncomeUrban
  returnOfIncomeYearIRPF
  returnOfIncomeExploredAreaCode
  returnOfIncomeExploredHectares
  exploredAreas {
    freeArea
    holder
    name
    registration
    registrationArea
    county
    municipality
    UF
  }
  financialPendency
  debtSituation
  financialInformation
  scoreType
  scoreNumber
  creditOpinion
  legalOpinion
  judicialActions {
    court
    authorName
    actionType
    causeValue
    processNumber
    distributionDate
    observations
    flag
  }
  files {
    ${fileQueryFields}
  }
  innovationDataUpdatedAt
`;

const financingAgProcessInfo = `
  id
  amount
  watching
  canStartPhase2
  prioritySince
  collateralType
  opportunitySaleType
  opportunityType
  opportunityRegional
  currentStates
  creditAnalystAssignedAt
  creditAnalystAssigned {
    id
    firstName
    lastName  
  }   
  campaign {
    id
    isActive
    isExternal
  }
  phase1 {
    ${phase1Info}
  }
  phase2 {
    id
    approvedCreditAmount
    status
    decisionNotes
    decisionChangedAt
    decisionChangedBy
    creditApprovalStatus
    creditApprovalDecisionNotes
    creditApprovalDecisionChangedAt
    creditApprovalDecisionChangedBy {
      ${userQueryFields}
    }
    escalationNotes
    escalatedAt
    escalatedBy {
      ${userQueryFields}
    }
    matriculas {
      id
      includedInAnalysis
      includedInFormalization
      matricula {
        id
        documentName
        documentUrl
      }
      kml {
        id
        documentName
      }
      details {
        id
        detailType
        emissionDate
        owners
        farmName
        totalArea
        cultivableArea
        cri
        state {
          ${stateQueryFields}

        }
        municipality {
          ${municipalityQueryFields}
        }
        registrationNumbers
        comments
        deforestationAfter2008
        permanentPreservationArea
        totalArea                        
        matriculaNumber        
        biome
        latitude
        longitude        
        preservationArea
        otherArea
        complianceConflictArea
        ibamaEmbargo
        conservationUnities
        indigenousLand
        ICMBIOEmbargo
        stateEmbargo
        quilimbolasLand
        legalComments
      }
    }
    collateral {
      startedAt
      startedBy
      id
      status
      decisionNotes
      decisionChangedAt
      decisionChangedBy {
        ${userQueryFields}
      }
      notes
      pendencies
      completedAt
      completedBy {
        ${userQueryFields}
      }
    }
    credit {
      ${creditInfo}
    }
    fieldMonitoring {
      id
      status
      startedAt
      startedBy {
        ${userQueryFields}
      }
      completedAt
      completedBy {
        ${userQueryFields}
      }
      decisionNotes
      decisionChangedAt
      decisionChangedBy {
        ${userQueryFields}
      }
    }
    files {
      ${fileQueryFields}
    }
  }
  phase3 {
    id
    status
    contractStatus
    signedDocumentsReviewedBy {
      ${userQueryFields}
    }
    signedDocumentsReviewedAt
    signedDocumentsReviewNotes
    signedDocumentsReceivedAt
    draftInstructions
    draftRegistrationNumber
    draftSentBy {
      ${userQueryFields}
    }
    draftSentAt
    startedAt
    startedBy {
      ${userQueryFields}
    }
    files {
      ${fileQueryFields}
    }
    physicalDocumentsReceived
    physicalDocumentsReceivedAt
    amendmentCreationNotes
    startingAmendmentCreationAt
    startingAmendmentCreationBy {
      ${userQueryFields}
    }
    amendmentRegistrationNumber
    amendmentInstructions
    amendmentInformationUpdatedAt
    amendmentSignatureRequestedAt
    amendmentSignatureRequestedNotes
    amendmentSignatureRequestedBy {
      ${userQueryFields}
    }
    amendmentSignedNotes
    amendmentTrackingNumber
    amendmentSignedAt
    amendmentSignedBy {
      ${userQueryFields}
    }
    approvedConditionals
  }
  phase4 {
    id
    status
    assignedToCreditAt
    sentToFundBy {
      ${userQueryFields}
    }
    sentToFundAt
    sentToFundNotes
    receivedByFundBy {
      ${userQueryFields}
    }
    receivedByFundAt
    receivedByFundNotes
    sentToManagerBy {
      ${userQueryFields}
    }
    sentToManagerAt
    sentToManagerNotes
    deniedBy {
      ${userQueryFields}
    }
    deniedAt
    deniedNotes
    submittedBy {
      ${userQueryFields}
    }
    submittedAt
    submittedNotes
    economicGroups {
      name
      cpfCnpj
    }
  }
  grower {
    id
    name
    cpfOrCnpj
    state {
      ${stateQueryFields}
    }
    municipality {
      ${municipalityQueryFields}
    }
    latitude
    longitude
    leadType
    salesforceId
    leadId
    agFinancingProcesses {
      id
      date
      updatedAt
      campaign {
        id
        isActive
        isExternal
      }
      orderInfo {
        opportunities {
          contractValue
          collateralType
          collateralGroup
        }
      }
    }
    additionalInfo {
      email
      mailingAddress
      phoneNumber
      salesPerson
      cellPhoneNumber
    }
  }
  orderInfo {
    campaign
    cpfOrCnpj
    client
    clientId
    state
    municipality
    maritalStatus
    sellingSeason
    rg
    collateralType
    opportunities {
      id
      dueDate
      backofficeApproval
      commercialApproval
      hasCommercialApproval
      contractValue
      contractHectares
      contractExpirationDate
      supplierPaymentDate
      collateralGroup
      quantity
      collateralType
      quantityOfMatriculas
      responsible
      collateralValue
      collateralBags
      collateralBags130
      collateralHectares
      pricePerBag
      bagsPerHectares
      tradingName
      tradingAddress
      type
      collateralDueDate
      channelPartnerName
      backgroundCheckType
      preCreditLimitApproved
      createdDate
      comments
      positivePoints
      attentionPoints
      products {
        productName
      }
      contract {
        id
        startDate
      }
    }
  }
  guarantorProcesses {
    id
    guaranteedBy {
      name
    }
    phase1 {
      ${phase1Info}
    }
    creditAnalysis {
      ${creditInfo}
    }
  }
  guaranteeData {
    id
    product
    state {
      ${stateQueryFields}
    }
    municipality {
      ${municipalityQueryFields}
    }
    value100Percent
    pricePerBag
    bagsPerHectares
    comments
  }
  agGroup {
    id
    cessionDate
    totalContractValue
    status
    isCurrentCession
    createdAt
  }
  importedExceptions
  importedConditionals
  parentId
`;

const eventsInfo = `
  allEvents {
    id
    eventType
    text
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
`;

const priorNegotiationData = `
  id
  amount
  date
  collateralType
  paymentStatus
  type
  campaign
  status
`;

export const financingAgFinancing = gql`
  query financingAgFinancing($agFinancingId: ID!) {
    financingAgFinancing(agFinancingId: $agFinancingId) {
      ${financingAgProcessInfo}
    }
  }
`;

export const financingAgFinancingGrowerName = gql`
  query financingAgFinancing($agFinancingId: ID!) {
    financingAgFinancing(agFinancingId: $agFinancingId) {
      grower {
        name
      }
    }
  }
`;

export const getAllFinancingEventsForGrower = gql`
  query financingAgFinancing($agFinancingId: ID!) {
    financingAgFinancing(agFinancingId: $agFinancingId) {
      id
      ${eventsInfo}
    }
  }
`;

export const getPriorNegotiations = gql`
  query getPriorNegotiations($agFinancingId: ID!) {
    priorNegotiations(agFinancingId: $agFinancingId) {
      ${priorNegotiationData}
    }
  }
`;

export const updateCreditInfoFromInnovation = gql`
  mutation updateCreditInfoFromInnovation($creditId: ID!) {
    updateCreditInfoFromInnovation(creditId: $creditId) {
      id
    }
  }
`;

export const upsertFinancingAgFinancing = gql`
  mutation upsertFinancingAgFinancing($data: AgFinancingInput!) {
    upsertFinancingAgFinancing(data: $data) {
      ${financingAgProcessInfo}
    }
  }
`;

export const updateCreditAnalystAssigned = gql`
  mutation updateCreditAnalystAssigned($agFinancingId: ID!, $userId: String) {
    updateCreditAnalystAssigned(agFinancingId: $agFinancingId, userId: $userId) {
      ${financingAgProcessInfo}
    } 
  }
`;

export const toggleAgFinancingWatch = gql`
  mutation toggleAgFinancingWatch($agFinancingId: ID!) {
    toggleAgFinancingWatch(agFinancingId: $agFinancingId)
  }
`;

export const toggleAgFinancingPriority = gql`
  mutation toggleAgFinancingPriority($agFinancingId: ID!, $isPriority: Boolean!, $notes: String) {
    toggleAgFinancingPriority(agFinancingId: $agFinancingId, isPriority: $isPriority, notes: $notes) {
      prioritySince
    }
  }
`;

export const closeNegotiation = gql`
  mutation closeNegotiation($agFinancingId: ID!, $reason: String) {
    closeNegotiation(agFinancingId: $agFinancingId, reason: $reason) {
      ${financingAgProcessInfo}
      ${eventsInfo}
    }
  }
`;

export const getAgFinancingPresignedUploadUrl = gql`
  query financingAgFinancingPresignedUploadUrl($data: AgFinancingFileUploadUrlInput!) {
    financingAgFinancingPresignedUploadUrl(data: $data) {
      presignedUrl
      remoteFileName
    }
  }
`;

export const getAgFinancingPresignedUploadUrlMultiple = gql`
  query financingAgFinancingPresignedUploadUrlMultiple($data: [AgFinancingFileUploadUrlInput]!) {
    financingAgFinancingPresignedUploadUrlMultiple(data: $data) {
      presignedUrl
      remoteFileName
    }
  }
`;

export const removeFinancingAgFinancingFiles = gql`
  mutation removeFinancingAgFinancingFiles($fileIds: [String]!) {
    removeFinancingAgFinancingFiles(fileIds: $fileIds)
  }
`;

export const addAgFinancingTimeLineComment = gql`
  mutation addAgFinancingTimeLineComment($agFinancingId: ID!, $comment: String!) {
    addAgFinancingTimeLineComment(agFinancingId: $agFinancingId, comment: $comment)
  }
`;

export const saveEconomicGroups = gql`
  mutation saveEconomicGroups($data: SaveEconomicGroupInput) {
    saveEconomicGroups(data: $data) {
      id
      economicGroups {
        name
        cpfCnpj
      }
    }
  }
`;

export const syncBackgroundChecksInGroup = gql`
  mutation syncBackgroundChecksInGroup($referenceId: String!) {
    syncBackgroundChecksInGroup(referenceId: $referenceId) {
      id
    }
  }
`;

export const processFileUploadPatrimonyValuation = gql`
  mutation processFileUploadPatrimonyValuation($file: AgFinancingPatrimonyFileInput!) {
    processFileUploadPatrimonyValuation(file: $file)
  }
`;
